import { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import headerImg2 from "../assets/img/header-img2.svg";
import headerImg3 from "../assets/img/header-img3.svg";
import headerImg4 from "../assets/img/header-img4.svg";
import headerImg5 from "../assets/img/header-img5.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

const ROTATE_TEXTS = ["iOS Developer", "Mobile Developer", "App Developer"];
const TYPING_PERIOD = 2000;

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const headerImages = [headerImg, headerImg2, headerImg3, headerImg4, headerImg5];
  
  // Get initial random image, excluding none
  const getRandomImage = (excludeImage = null) => {
    let availableImages = excludeImage 
      ? headerImages.filter(img => img !== excludeImage)
      : headerImages;
    return availableImages[Math.floor(Math.random() * availableImages.length)];
  };

  const [currentImage] = useState(getRandomImage());

  const tick = useCallback(() => {
    let i = loopNum % ROTATE_TEXTS.length;
    let fullText = ROTATE_TEXTS[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(TYPING_PERIOD);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum((prevLoopNum) => prevLoopNum + 1);
      setDelta(500);
    }
  }, [isDeleting, loopNum, text]);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [delta, tick]);

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Website</span>
                <h1>{`Hi! I'm xqsadness`} <span className="txt-rotate" data-period="1000" data-rotate='["iOS Developer", "Mobile Developer", "App Developer"]'><span className="wrap">{text}</span></span></h1>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                  <a href="#connect" style={{textDecoration: 'none'}} > 
                  <button>Let's Connect <ArrowRightCircle size={25} /></button>
                  </a>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img 
                    src={currentImage} 
                    alt="xqsadness Header"
                    className="header-image"
                  />
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
